export default "__VITE_ASSET__BjCyJBpP__"